import { Button, Flex } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { DayOfTheWeek, selectedDaysOfTheWeekToLabelMap } from '../types';

export function handleSelectDays(
  day: DayOfTheWeek,
  setSelectedDays: React.Dispatch<React.SetStateAction<DayOfTheWeek[]>>,
) {
  setSelectedDays((current) =>
    current.includes(day)
      ? current.filter((d) => d !== day)
      : [...current, day],
  );
}

export const DayOfTheWeekButton = ({
  day,
  onClick,
  selectedDays,
  isError,
}: {
  day: DayOfTheWeek;
  onClick: () => void;
  selectedDays: DayOfTheWeek[];
  isError: boolean;
}) => {
  const isCurrentlySelected = selectedDays && selectedDays.includes(day);
  return (
    <Button
      height="40px"
      width="44px"
      mr="15px"
      padding="6px 16px"
      onClick={onClick}
      colorScheme={isError ? 'red' : 'blue'}
      variant={isCurrentlySelected ? 'solid' : 'outline'}
    >
      {selectedDaysOfTheWeekToLabelMap[day]}
    </Button>
  );
};

type DaysOfTheWeekSelectButtonsProps = {
  onSelectDay: (day: DayOfTheWeek) => void;
  selectedDays: DayOfTheWeek[];
  error: string;
};
export const DaysOfTheWeekSelectButtons = ({
  onSelectDay,
  selectedDays,
  error,
}: DaysOfTheWeekSelectButtonsProps) => {
  const isError = error.length > 0;
  return (
    <Flex width="100%" borderRadius="8px" height="40px">
      {_.map(DayOfTheWeek, (day) => {
        return (
          <DayOfTheWeekButton
            key={`select-day-of-the-week-button-${day}`}
            day={day}
            onClick={() => onSelectDay(day)}
            selectedDays={selectedDays}
            isError={isError}
          />
        );
      })}
    </Flex>
  );
};
